var gtag = null;
var gaData = {};

export function gaSetData(key, value) {
    gaData[key] = value;
}

export function gaEvent(eventParams) {
    var eventName;

    if (gtag === null && window.gtag) {
        gtag = window.gtag;
    }

    if (gtag) {
        if (gaData.isRoom) {
            eventName = 'cnv_room';
            eventParams.ACTION = 'room_' + eventParams.ACTION;
        } else {
            eventName = 'cnv_meeting';
            eventParams.ACTION = 'meeting_' + eventParams.ACTION;
        }

        eventParams.user_id = gaData.userId;
        eventParams.video_meeting = gaData.meetingId;

        // console.log('event', eventName, eventParams);

        gtag('event', eventName, eventParams);
    }
}



// WEBPACK FOOTER //
// ./src/functions/gtag.js